import React, { useEffect, useState } from "react";
import { Row, Col, ListGroup, Spinner } from "react-bootstrap";
import axios from "axios";
import { getReleasedReleases, markReleaseSeen } from "../../releasesApi";
import ReleaseNotesViewer from "./ReleaseNotesViewer";

// Userprofile "Release Notes" section — lists all released releases (newest
// first) and shows the shared viewer for the selected one.
export default function ReleaseNotesSection() {
  const [releases, setReleases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getReleasedReleases()
      .then((data) => {
        if (cancelled) return;
        const list = Array.isArray(data) ? data : [];
        setReleases(list);
        if (list.length) {
          setSelectedId(list[0]._id);
          // Opening this section counts as viewing the release notes: it
          // stamps lastSeenReleaseAt (suppressing the first-login modal) and
          // unlocks completion of the user's RELEASE_NOTES task. The fresh
          // JWT replaces the session token in one round-trip.
          markReleaseSeen()
            .then((res) => {
              if (res?.token) {
                sessionStorage.setItem("user", res.token);
                axios.defaults.headers.common["authorization"] = `Bearer ${res.token}`;
              }
            })
            .catch(() => {});
        }
      })
      .catch((err) => console.error("Error fetching releases:", err))
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" variant="primary" />
        <p className="mt-2">Loading release notes…</p>
      </div>
    );
  }

  if (releases.length === 0) {
    return <p className="text-center py-4 mb-0">No releases found.</p>;
  }

  const selected = releases.find((r) => r._id === selectedId) || releases[0];

  return (
    <Row>
      <Col xs={12} md={3} className="mb-3 mb-md-0">
        <ListGroup>
          {releases.map((release) => (
            <ListGroup.Item
              key={release._id}
              action
              active={release._id === selected._id}
              onClick={() => setSelectedId(release._id)}
            >
              <div className="fw-semibold">{release.name}</div>
              {release.releasedAt && (
                <small>
                  {new Date(release.releasedAt).toLocaleDateString("en-GB")}
                </small>
              )}
            </ListGroup.Item>
          ))}
        </ListGroup>
      </Col>
      <Col xs={12} md={9}>
        <ReleaseNotesViewer release={selected} />
      </Col>
    </Row>
  );
}
